@if (isHaie) {
  <bdo-coop-teaser
    class="re-block re-mt-45"
    data-qa="haie-teaser"
    [title]="'teaser.haie.title' | translate"
  [linkData]="[{
    href: 'teaser.haie.link' | translate,
    linkName: 'teaser.haie.linkName' | translate,
    tracking: [TRACKING.LOCATION.HAIE_TEASER, TRACKING.ACTION.GOTO, TRACKING.LOCATION.HAIE_LANDING]
  }]"
    [externalIconSrc]="'teaser.haie.logo' | translate"
    >
    {{ 'teaser.haie.description' | translate }}
  </bdo-coop-teaser>
}
